module.exports = __webpack_public_path__ + "media/images/front/mid_g/banner_shelf-f303a43de35582e1eac939fc7f41ec73.png";